import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fortawesome/fontawesome-free/css/all.min.css";
// TODO React19 https://github.com/frontend-collective/react-sortable-tree/discussions/942
// import "react-sortable-tree/style.css";
import "./assets/scss/core.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
